import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import SuccessScreen from 'creative-ui/oktaComponents/SuccessScreen';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import croixSvg from '@/assets/croix.svg';
import { BackToLogin } from '@/components/Buttons/BackToLogin';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';

import { useResetPasswordErrorManager } from './hooks/resetPasswordErrorManager';

// Main Reset Password Error Screen
function ResetPasswordErrorScreen() {
  const { t } = useTranslation('resetPasswordError');
  useTransactionLocale();

  const { texts } = useResetPasswordErrorManager();

  useEffect(() => {
    trackPageView('change/password/error');
  }, []);

  const title = texts?.eventTitle || t('header.title');
  const description = texts?.description || t('header.description');

  document.title = t('pageTitle');

  return (
    <BaseWrapper>
      <SuccessScreen
        title={title}
        image={croixSvg}
        text={description}
        isTextBeforeImage={false}>
        <BackToLogin variant="primary" />
      </SuccessScreen>
    </BaseWrapper>
  );
}

export default ResetPasswordErrorScreen;
